const ApiTags = {
  EVENT_LIST: 'Events',
  BRANCHES: 'Branches',
  LEAD_MANAGEMENT: 'LeadManagement',
  LEAD_EVENTS: 'LeadEvents',
  LEAD_TASKS: 'LeadTasks',
  LEAD_CALLS: 'LeadCalls',
  LEAD_STATUS: 'LeadStatus',
  META_PROVIDER: 'MetaProvider',
  DYNAMIC_COMPONENTS: 'DynamicComponents',
  LEAD_ORG_CONFIG: 'LeadOrgConfig',
  SUBSCRIPTION_LEDGER: 'SubscriptionLedger',
  BRANCH_CONFIG: 'BranchConfig'
};

export default ApiTags;
